import { BaseAuthorizedRequest, GenericResponse } from "visible-ui";
import { AxiosResponse } from "axios";
import { SurveyUser } from "../../model/user";

export default class DeactivateUser extends BaseAuthorizedRequest<
  GenericResponse,
  GenericResponse
> {
  constructor(accessToken: string, user: SurveyUser) {
    super(
      "PUT",
      `/deactivate/`,
      {
        payload: user,
      },
      accessToken
    );
  }

  processResponse({ data }: AxiosResponse<GenericResponse>): GenericResponse {
    return data;
  }
}
